import { Button, Col, Form, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { SelectAnimalBreed, SelectFarmStatus, SelectMultiAnimalType, SelectOwner } from '../../../components/selects';
import { SearchOutlined } from '@ant-design/icons';


interface IProps {
  formField: any;
  form: any;
  onReset: () => void;
  onSearch: () => void;
}

export const FilterBreedingFarm = (props: IProps) => {
  const { t } = useTranslation();

  return (
    <Form form={props.form} layout='vertical'>
      <Row gutter={10}>
        <Col span={6}>
          <Form.Item
            label="Название фермы"
            name={props.formField.name}
          >
            <Input autoComplete="off" />
          </Form.Item>

        </Col>
        <Col span={6}>
        <Form.Item
          label="Статус фермы"
          name={props.formField.farmsStatusId}
        >
          <SelectFarmStatus />
        </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Виды животного"
            name={props.formField.animalTypeIds}
          >
            <SelectMultiAnimalType />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Порода животных"
            name={props.formField.animalBreedIds}
          >

            <SelectAnimalBreed />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Владелец"
            name={props.formField.ownerId}
          >
            <SelectOwner />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Адрес"
            name={props.formField.address}
          >
            <Input autoComplete="off" />
          </Form.Item>
        </Col>
        <Col span={6}>
        <div style={{marginTop:30}}>
            <Button 
              type="primary" 
              shape="default" 
              size="middle"
              icon={<SearchOutlined />} 
              style={{marginRight: 'auto'}}
              onClick={props.onSearch}
            >{t('general.search')}</Button>
            <Button
             size="small" 
             type="link" 
             onClick={props.onReset}
             style={{color: "orange"}}
             >{t('general.reset')}</Button>
            </div>
        </Col>
      </Row>
    </Form>
  )
}
